<template>
<span>
    <v-layout mb-4>
        <v-flex xs10 ml-3>
            <h2 class="lime--text lighten-1 pt-3">Gerenciar Medidas - Inclusão</h2>
        </v-flex>
        <v-flex xs2 mr-3 text-right>
            <v-btn color="blue-grey" class="black--text" :to="{name: 'product-measures'}">
                <v-icon dark>keyboard_arrow_left</v-icon>
                Voltar
            </v-btn>
        </v-flex>
    </v-layout>
    <form-product-measure :btnLabel="btnLabel"></form-product-measure>
</span>
</template>

<script>
import FormProductMeasureComponent from "./partial/FormProductMeasureComponent";

export default {
    name: "AddProductMeasuresComponent",
    data() {
        return {
            btnLabel: 'Incluir'
        }
    },
    methods: {

    },
    components: {
        formProductMeasure: FormProductMeasureComponent,
    }
};
</script>

<style scoped>

</style>
